export const config = {
  fieldControl: false,
  searchTypeWidth: 150, // 搜索框宽度
  search: [
    {
      label: '适用门店',
      name: 'companyId',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
    },
    {
      label: '适用商品',
      name: 'goodsId',
      labelProps: {
        width: 120,
      },
      itemType: 'custom',
      render: 'goodsRender',
    },
    {
      label: '品牌',
      name: 'brandId',
      itemType: 'custom',
      render: 'brandRender',
    },
  ],
  columns: [
    { title: '适用商品', dataIndex: 'goodsName', width: 120 },
    { title: '适用门店', dataIndex: 'companyName', width: 120 },
    { title: '品牌', dataIndex: 'brandName', width: 120 },
    { title: '限制类型', dataIndex: 'filterTypeName', width: 120 },
    { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
  ],
  footer: [{ label: '新增配置', type: 'primary', events: ['onClick:onAdd'] }],
  batchActions: [{ label: '批量删除', danger: true, events: ['onClick:onBatchDelete'] }],
}
